import { TrackingNumberSearch } from 'src/app/core/models/operations';

export const DISPLAY_CONSTS = {
  HEADER: $localize`Add Delivery`.toUpperCase(),
  SEARCH_TRACKING: $localize`Search by Tracking Number`,
  SELECT_CUSTOMER_BUTTON: $localize`Select Customer`,
  BACK_BUTTON: $localize`Back`,
  SEARCH_BUTTON: $localize`Search`,
  ROUTE: $localize`Route %s`,
};

export interface DeliveryStopReturn {
  trackingNumData?: TrackingNumberSearch;
  trackNumSearch: boolean;
  customer: boolean;
}
